/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ArchiveRouteImport } from './routes/archive'
import { Route as ChoresRouteImport } from './routes/chores'
import { Route as HabitsRouteImport } from './routes/habits'
import { Route as HelpRouteImport } from './routes/help'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as InsightsRouteImport } from './routes/insights'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as RoutinesRouteImport } from './routes/routines'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as TasksRouteImport } from './routes/tasks'
import { Route as ListsIndexRouteImport } from './routes/lists.index'
import { Route as ListsListIdRouteImport } from './routes/lists.$listId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchiveRoute = ArchiveRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => rootRouteImport,
} as any)
const ChoresRoute = ChoresRouteImport.update({
  id: '/chores',
  path: '/chores',
  getParentRoute: () => rootRouteImport,
} as any)
const HabitsRoute = HabitsRouteImport.update({
  id: '/habits',
  path: '/habits',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const InsightsRoute = InsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewRoute = ReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => rootRouteImport,
} as any)
const RoutinesRoute = RoutinesRouteImport.update({
  id: '/routines',
  path: '/routines',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksRoute = TasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const ListsIndexRoute = ListsIndexRouteImport.update({
  id: '/lists/',
  path: '/lists/',
  getParentRoute: () => rootRouteImport,
} as any)
const ListsListIdRoute = ListsListIdRouteImport.update({
  id: '/lists/$listId',
  path: '/lists/$listId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRoute
  '/chores': typeof ChoresRoute
  '/habits': typeof HabitsRoute
  '/help': typeof HelpRoute
  '/inbox': typeof InboxRoute
  '/insights': typeof InsightsRoute
  '/library': typeof LibraryRoute
  '/review': typeof ReviewRoute
  '/routines': typeof RoutinesRoute
  '/settings': typeof SettingsRoute
  '/tasks': typeof TasksRoute
  '/lists/$listId': typeof ListsListIdRoute
  '/lists/': typeof ListsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRoute
  '/chores': typeof ChoresRoute
  '/habits': typeof HabitsRoute
  '/help': typeof HelpRoute
  '/inbox': typeof InboxRoute
  '/insights': typeof InsightsRoute
  '/library': typeof LibraryRoute
  '/review': typeof ReviewRoute
  '/routines': typeof RoutinesRoute
  '/settings': typeof SettingsRoute
  '/tasks': typeof TasksRoute
  '/lists/$listId': typeof ListsListIdRoute
  '/lists': typeof ListsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRoute
  '/chores': typeof ChoresRoute
  '/habits': typeof HabitsRoute
  '/help': typeof HelpRoute
  '/inbox': typeof InboxRoute
  '/insights': typeof InsightsRoute
  '/library': typeof LibraryRoute
  '/review': typeof ReviewRoute
  '/routines': typeof RoutinesRoute
  '/settings': typeof SettingsRoute
  '/tasks': typeof TasksRoute
  '/lists/$listId': typeof ListsListIdRoute
  '/lists/': typeof ListsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/archive'
    | '/chores'
    | '/habits'
    | '/help'
    | '/inbox'
    | '/insights'
    | '/library'
    | '/review'
    | '/routines'
    | '/settings'
    | '/tasks'
    | '/lists/$listId'
    | '/lists/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/archive'
    | '/chores'
    | '/habits'
    | '/help'
    | '/inbox'
    | '/insights'
    | '/library'
    | '/review'
    | '/routines'
    | '/settings'
    | '/tasks'
    | '/lists/$listId'
    | '/lists'
  id:
    | '__root__'
    | '/'
    | '/archive'
    | '/chores'
    | '/habits'
    | '/help'
    | '/inbox'
    | '/insights'
    | '/library'
    | '/review'
    | '/routines'
    | '/settings'
    | '/tasks'
    | '/lists/$listId'
    | '/lists/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArchiveRoute: typeof ArchiveRoute
  ChoresRoute: typeof ChoresRoute
  HabitsRoute: typeof HabitsRoute
  HelpRoute: typeof HelpRoute
  InboxRoute: typeof InboxRoute
  InsightsRoute: typeof InsightsRoute
  LibraryRoute: typeof LibraryRoute
  ReviewRoute: typeof ReviewRoute
  RoutinesRoute: typeof RoutinesRoute
  SettingsRoute: typeof SettingsRoute
  TasksRoute: typeof TasksRoute
  ListsListIdRoute: typeof ListsListIdRoute
  ListsIndexRoute: typeof ListsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archive': {
      id: '/archive'
      path: '/archive'
      fullPath: '/archive'
      preLoaderRoute: typeof ArchiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chores': {
      id: '/chores'
      path: '/chores'
      fullPath: '/chores'
      preLoaderRoute: typeof ChoresRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/habits': {
      id: '/habits'
      path: '/habits'
      fullPath: '/habits'
      preLoaderRoute: typeof HabitsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/insights': {
      id: '/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof InsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review': {
      id: '/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof ReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/routines': {
      id: '/routines'
      path: '/routines'
      fullPath: '/routines'
      preLoaderRoute: typeof RoutinesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks': {
      id: '/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof TasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lists/': {
      id: '/lists/'
      path: '/lists'
      fullPath: '/lists/'
      preLoaderRoute: typeof ListsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lists/$listId': {
      id: '/lists/$listId'
      path: '/lists/$listId'
      fullPath: '/lists/$listId'
      preLoaderRoute: typeof ListsListIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArchiveRoute: ArchiveRoute,
  ChoresRoute: ChoresRoute,
  HabitsRoute: HabitsRoute,
  HelpRoute: HelpRoute,
  InboxRoute: InboxRoute,
  InsightsRoute: InsightsRoute,
  LibraryRoute: LibraryRoute,
  ReviewRoute: ReviewRoute,
  RoutinesRoute: RoutinesRoute,
  SettingsRoute: SettingsRoute,
  TasksRoute: TasksRoute,
  ListsListIdRoute: ListsListIdRoute,
  ListsIndexRoute: ListsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
